import { createFileRoute } from "@tanstack/react-router";
import { McpPage } from "@/components/mcp-page";
import { mcpHead, mcpLoader } from "@/components/mcp-content";

export const Route = createFileRoute("/$locale/mcp")({
  loader: mcpLoader,
  head: mcpHead,
  component: McpPage,
});
